export const User = {
	 // User related Api calls

	login(params) {
		return this.service.get(
			'/api/bubble-login',
			params,
			response => Promise.resolve(response)
		)
	},

	loadMe(params) {
		return this.service.get(
			'/api/me',
			params,
			response => Promise.resolve(response)
		)
	},

	loadApplicationsJobs(params) {
		return this.service.get(
			'/api/jobs/applications',
			params,
			response => Promise.resolve(response)
		)
	},

	loadSavedJobs(params) {
		return this.service.get(
			'/api/jobs/saved',
			params,
			response => Promise.resolve(response)
		)
	},

  loadRecommendedJobs(params) {
		return this.service.get(
			'/api/jobs/recommended',
			params,
			response => Promise.resolve(response)
		)
	},

	loadFollowedOrgs(params) {
		return this.service.get(
			'/api/organisations/followed',
			params,
			response => Promise.resolve(response)
		)
	}
}
